export function sum(num1: number, num2: number): number {
    return num1 + num2;
  }